import { render, staticRenderFns } from "./prescriptions.table.vue?vue&type=template&id=175669c8&"
import script from "./prescriptions.table.vue?vue&type=script&lang=js&"
export * from "./prescriptions.table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports